import React from 'react';
import {FaIcon} from '../../FaIcon';
import {TemplateBlockCard} from './TemplateBlockCard';


export function TemplateSectionCard({
    section, sectionIndex, totalSections, t, isOwner,
    onMoveUp, onMoveDown, onDelete, onEditBlock, onAddBlock
}) {
    const sectionTitle = section.title || section.id || `${t('templates.section_label')} ${sectionIndex + 1}`;
    const blocks = section.blocks || [];

    return (
        <div className="template-section-card">
            <div className="template-section-card-header">
                <h4 className="template-section-card-title">
                    <FaIcon iconName="layer-group"/>
                    {sectionTitle}
                </h4>
                {isOwner && (
                    <div className="template-section-card-actions">
                        <button
                            className="template-section-action-btn"
                            onClick={() => onMoveUp(sectionIndex)}
                            disabled={sectionIndex === 0}
                            title={t('templates.section_move_up')}
                        >
                            <FaIcon iconName="chevron-up"/>
                        </button>
                        <button
                            className="template-section-action-btn"
                            onClick={() => onMoveDown(sectionIndex)}
                            disabled={sectionIndex === totalSections - 1}
                            title={t('templates.section_move_down')}
                        >
                            <FaIcon iconName="chevron-down"/>
                        </button>
                        <button
                            className="template-section-action-btn -danger"
                            onClick={() => onDelete(sectionIndex)}
                            title={t('templates.section_delete')}
                        >
                            <FaIcon iconName="xmark"/>
                        </button>
                    </div>
                )}
            </div>
            <div className="template-section-grid">
                {blocks.map((block, blockIndex) => (
                    <TemplateBlockCard
                        key={block.id || blockIndex}
                        block={block}
                        t={t}
                        isOwner={isOwner}
                        onClick={(b) => onEditBlock(sectionIndex, blockIndex, b)}
                    />
                ))}
            </div>
            {isOwner && (
                <div className="template-section-card-footer">
                    <button
                        className="template-section-add-block-btn"
                        onClick={() => onAddBlock(sectionIndex)}
                    >
                        <FaIcon iconName="plus"/>
                        {t('templates.add_block')}
                    </button>
                </div>
            )}
        </div>
    );
}
